import type { BookingStatus } from '@/api';

export const SUCCESS_BOOKING_STATUS = ['CONFIRMED', 'COMPLETED'];
export const PENDING_BOOKING_STATUS = [
	'PAYMENT_PENDING',
	'PAYMENT_SUCCESS_BOOKING_PENDING',
];
export const FAILED_BOOKING_STATUS = ['FAILED'];

export const CONFIRMATION_STYLE_MAP: Record<
	BookingStatus,
	{
		iconName: string;
		title: string;
		titleColor: string;
		bgColor: string;
	}
> = {
	CONFIRMED: {
		iconName: 'GlitterSuccessTick',
		title: 'Ride Confirmed',
		titleColor: 'text-success-subtle',
		bgColor: 'bg-success-subtle',
	},
	COMPLETED: {
		iconName: 'SuccessTick',
		title: 'Ride Completed',
		titleColor: 'text-success-subtle',
		bgColor: 'bg-success-subtle',
	},
	CANCELLED: {
		iconName: 'WarningTick',
		title: 'Ride Cancelled',
		titleColor: 'text-primary',
		bgColor: 'bg-warning-subtle',
	},
	RESCHEDULED: {
		iconName: 'GlitterSuccessTick',
		title: 'Ride Rescheduled',
		titleColor: 'text-success-subtle',
		bgColor: 'bg-success-subtle',
	},
	PAYMENT_PENDING: {
		iconName: 'PendingTimer',
		title: 'Payment Pending',
		titleColor: 'text-primary',
		bgColor: 'bg-warning-subtle',
	},
	PAYMENT_SUCCESS_BOOKING_PENDING: {
		iconName: 'PendingTimer',
		title: 'Booking In Progress',
		titleColor: 'text-primary',
		bgColor: 'bg-warning-subtle',
	},
	FAILED: {
		iconName: 'CriticalClose',
		title: 'Booking Failed',
		titleColor: 'text-critical-subtle',
		bgColor: 'bg-critical-subtle',
	},
};

export const DEFAULT_CONFIRMATION_STYLE = {
	iconName: 'PendingTimer',
	title: 'Booking in progress',
	titleColor: 'text-primary',
	bgColor: 'bg-tertiary',
} as const;

export const TRIP_DETAIL_STYLE_MAP: Record<
	BookingStatus,
	{ text: string; textColor: string }
> = {
	CONFIRMED: { text: 'Confirmed', textColor: 'text-success' },
	COMPLETED: { text: 'Completed', textColor: 'text-success' },
	CANCELLED: { text: 'Cancelled', textColor: 'text-critical-subtle' },
	RESCHEDULED: { text: 'Rescheduled', textColor: 'text-success' },
	PAYMENT_PENDING: {
		text: 'Payment Pending',
		textColor: 'text-warning-subtle',
	},
	PAYMENT_SUCCESS_BOOKING_PENDING: {
		text: 'Booking In Progress',
		textColor: 'text-warning-subtle',
	},
	FAILED: { text: 'Failed', textColor: 'text-critical-subtle' },
};
